import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-heading font-bold text-background-50 mb-4">
              继母的朋友们漫画
            </h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              最全面的继母的朋友们漫画资讯平台，提供完整剧情介绍、角色解析、更新资讯与阅读指南。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              内容分类
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="#faq"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                >
                  常见问题
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              免责声明
            </h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              本站为继母的朋友们漫画资讯分享平台，所有内容仅供学习交流使用。漫画版权归原作者及出版方所有。
            </p>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-400">
            &copy; {currentYear} 继母的朋友们漫画资讯站. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
              aria-label="微博"
              rel="nofollow"
            >
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
              aria-label="微信"
              rel="nofollow"
            >
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
              aria-label="B站"
              rel="nofollow"
            >
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}